<template>
	<div class="assets-wrapper">
		<!--    <portfolio-buttons />-->
		<div class="row mb-2">
			<transactions-strategy-picker
					class="portfolio-filter col-12 offset-md-8 col-md-4"
			/>
		</div>
		<div class="card mt-1">
			<div class="card-header">
				Vývoj majetku
			</div>
			<div class="card-body chart-area pt-2 pb-1">
				<assets-trend-graph v-if="chartPage === 1"/>
				<assets-composition-full v-if="chartPage === 2"/>
				<div class="text-center mb-1">
					<paginator
							:pages="2"
							:page="chartPage"
							@changed="chartPage = $event"
					/>
				</div>
			</div>
		</div>
		<div class="card mt-4">
			<div class="card-header">Majetok</div>
			<div class="card-body p-0">
				<Loading v-if="loadingList" class="my-5"/>
				<data-grid
						:items="list.assets"
						:columns="columns"
						:on-detail-open="loadDetail"
						v-else
				>
					<template slot="rate" slot-scope="{ item }">
						<profit :value="parseFloat(item.rate)"/>
					</template>
					<template slot="value" slot-scope="{ item }">
						{{ itemValue(item.count, item.value) | number }}
					</template>
					<template slot="valueEUR" slot-scope="{ item }">
						{{ itemValue(item.count, item.value_eur) | number }}
					</template>
					<template slot="price" slot-scope="{ item }">
						<span v-if="item.code">{{ item.price | number }}</span>
						<span v-else></span>
					</template>
					<template slot="count" slot-scope="{ item }">
						<span>{{ item.count | number(null) }}</span>
					</template>
					<template slot="detail" slot-scope="{ item }">
						<!--            <Loading v-if="!item.detail && detailPage === 1" class="mb-5 p-5" />-->
						<div v-if="item.detail && detailPage === 1" class="row mt-md-4">
							<div class="col-12 col-md-7 order-md-2">
								<asset-value-graph :points="item.detail.graph"/>
							</div>
							<div class="col-12 col-md-5 pt-md-3 order-md-1">
								<strong>Podrobnosti</strong>
								<div class="details-wrapper">
									<div class="row">
										<div class="col-md-4">Emitent:</div>
										<div class="col-md-8">{{ item.detail.detail.issuer }}</div>
									</div>
									<div class="row">
										<div class="col-md-4">Krajina:</div>
										<div class="col-md-8">{{ item.detail.detail.country }}</div>
									</div>
								</div>
							</div>
						</div>
						<Loading
								v-if="!item.transactions && detailPage === 2"
								class="mb-5 p-5"
						/>
						<div
								v-if="item.transactions && detailPage === 2"
								class="row ml-0 mt-md-2"
						>
							<data-grid
									class="no-style"
									:items="item.transactions"
									:columns="transactionsColumns"
									:show-detail="false"
							>
								<template slot="date" slot-scope="{ item }">
									{{ item.date | date }}
								</template>
								<template slot="price" slot-scope="{ item }">
									{{ item.price | number(2) }}
								</template>
								<template slot="volume" slot-scope="{ item }">
									{{ item.volume | number(2) }}
								</template>
							</data-grid>
						</div>
						<!--            <div class="text-center mb-1">-->
						<!--              <paginator-->
						<!--                :pages="2"-->
						<!--                :page="detailPage"-->
						<!--                @changed="detailPage = $event"-->
						<!--              />-->
						<!--            </div>-->
					</template>
				</data-grid>
			</div>
		</div>
		<div class="mt-3 text-right" v-if="!loadingList">
			<button class="btn btn-highlighted btn-warning" @click="exportToXls">Exportovať</button>
		</div>
	</div>
</template>

<script>
// import PortfolioButtons from "../../../components/PortfolioButtons";
import AssetsTrendGraph from "../../../components/AssetsTrendGraph";
import DataGrid from "../../../components/DataGrid";
import Profit from "../../../components/profit";
import AssetValueGraph from "../../../components/AssetValueGraph";
import Paginator from "../../../components/Paginator";
import AssetsCompositionFull from "./AssetsCompositionFull";
import Loading from "../../../components/Loading";
import TransactionsStrategyPicker from "@/components/TransactionsStrategyPicker";
import {token} from "../../../store/modules/account";
import {prepareQueryParameters} from "../../../store/api";

export default {
	name: "Assets",
	components: {
		AssetsCompositionFull,
		Paginator,
		AssetValueGraph,
		Profit,
		DataGrid,
		AssetsTrendGraph,
		TransactionsStrategyPicker,
		Loading
	},
	computed: {
		portfolio() {
			return this.$store.state.portfolio.selected;
		},
		list() {
			return this.$store.state.assets.list;
		},
		loadingList() {
			return this.$store.state.assets.loadingList;
		},
		loadingDetail() {
			return this.$store.state.assets.loadingDetail;
		},
		loadingTransactions() {
			return this.$store.state.assets.loadingTransactions;
		},
		loading() {
			return this.$store.state.assets.loading;
		}
	},
	watch: {
		portfolio() {
			this.loadData();
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.$store.dispatch("assets/assets", {
				investmentStrategyId: this.portfolio
			});
		},
		loadDetail(asset, index) {
			this.detailPage = 1;
			this.$store.dispatch("assets/assetDetail", {
				id: asset.id,
				index,
				portfolio: this.portfolio,
				strategyId: asset.investment_strategy_id
			});
			// this.$store.dispatch("assets/assetTransactions", {
			//   code: asset.code,
			//   index,
			//   portfolio: this.portfolio
			// });
		},
		showModal(code, isSale) {
			this.tradeRequest.isSale = isSale;
			this.tradeRequest.code = code;
			this.$refs.request.show();
		},
		exportToXls() {
			const params = {
				token: token(),
				investmentStrategyId: this.portfolio,
        clientToken: this.$store.state.account.tempUser.token
			};

			window.open(process.env.VUE_APP_API_LINK + `asset-accounts/export-assets.xlsx?${prepareQueryParameters(params)}`);
		},
		itemValue(count, value) {
			return count * value;
		}
	},
	data() {
		return {
			chartPage: 1,
			detailPage: 1,
			columns: [
				{
					name: "Aktívum",
					slug: "asset"
				},
				{
					name: "ISIN",
					slug: "isin"
				},
				{
					name: "Typ",
					slug: "type"
				},
				{
					name: "Stratégia",
					slug: "portfolio"
				},
				{
					name: "Počet",
					slug: "count"
				},
				// {
				//   name: "Cena",
				//   slug: "price"
				// },
				{
					name: "Mena",
					slug: "currency"
				},
				{
					name: "Hodnota",
					slug: "value"
				},
				{
					name: "Hodnota v EUR",
					slug: "valueEUR"
				},
				{
					name: "P/L",
					slug: "rate"
				}
			],
			transactionsColumns: [
				{
					name: "História",
					slug: "date"
				},
				{
					name: "Popis",
					slug: "description"
				},
				{
					name: "Počet",
					slug: "count"
				},
				{
					name: "Cena",
					slug: "price"
				},
				{
					name: "Mena",
					slug: "currency"
				},
				{
					name: "Objem",
					slug: "volume"
				}
			],
			tradeRequest: {
				isSale: true,
				code: ""
			}
		};
	}
};
</script>

<style lang="scss">
.assets-wrapper {
	.chart-area {
		min-height: 383px;

		@include media-breakpoint-down(sm) {
			padding-left: 0;
			padding-right: 0;
		}
	}

	.table th {
		padding-right: 10px !important;
		padding-left: 10px !important;
	}
}

.portfolio-filter {
	.form-control {
		height: 30px;
		font-size: 14px;
		padding-top: 5px;
		background-color: $dark-gray;
		color: white;
	}
}
</style>
